angular.module( 'acme.view.application.pos.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posList = {
        name: 'application.pos.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'PosListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator',
          pageClass: 'application application-pos-list',
          /** Secure With Permissions **/
          permissions: ['WL_POS_CONFIG_VIEW']
        }
      };

    $stateProvider
      .state(posList);
});
